import React from 'react'

const PageBannerMessage = props => {
  const { children } = props
  return <span className="message">{children}</span>
}
export default PageBannerMessage
